export default __webpack_public_path__ + "static/media/bellow_header_gc_round.00620e63.svg";